export default "/images/ec044441df686f632b9f99b41bc6ec39.avif";